import {
  getDashboardPurchasedLicensesControllerListQueryKey,
  getDashboardPurchasedLicensesControllerStatsQueryKey,
} from "@/api/__generated__/dashboard-purchased-licenses/dashboard-purchased-licenses";

export const PURCHASED_LICENSES_INVALIDATE_KEYS = [
  getDashboardPurchasedLicensesControllerListQueryKey(),
  getDashboardPurchasedLicensesControllerStatsQueryKey(),
];
